export const baseUrl = `${window.location.protocol}//${window.location.host}`;
